module.exports = __webpack_public_path__ + "img/model.e21dc076.jpg";